import { render } from "./TopBar.vue?vue&type=template&id=6c630ee8"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=6c630ee8&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__